module.exports = __webpack_public_path__ + "static/media/people-withdraw.8bc493ff.svg";